import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { AutomationProcessDD, CMSite, CMSiteListResponse, CMClub, CMClubResponse } from '../../../models/cm-club-service.model';
import { keyValue, SimpleResponse } from '../../../models/generic-response.model';
import { CMClubService } from '../../../services/cm-club.service';
import { NotificationService } from '../../../services/notification.service';
import { AppConfigService } from '../../../services/shared/app-config.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';

@Component({
    selector: 'app-lm-triggers',
    templateUrl: './lm-triggers.component.html',
    styleUrl: './lm-triggers.component.css'
})
export class LmTriggersComponent implements OnDestroy {
    encryptedUser: string = '';
    user: BCMCLPUser;
    webFormList: keyValue[] = [];
    automationProcessList: AutomationProcessDD[] = [];
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };

    site = {} as CMSite;
    newLeadId: number = 0;
    newMemberId: number = 0;
    contractSent: number = 0;
    contractOpen: number = 0;
    waitingCountersign: number = 0;
    memberAdded: number = 0;
    contractUpgraded: number = 0;
    contractRenewed: number = 0;
    memberTerminated: number = 0;
    contractExpired: number = 0;
    contactUpdateId: number = 0;
    referralRequest: number = 0;
    enableAutomationAlert: boolean = true;
    sites: CMSite[] = [];
    curSite: CMSite = <CMSite>{};
    showSpinner: boolean;
    submitted: boolean;
    curSiteSub: Subscription;
    clpCompanyId: number;
    isShowClone: boolean = false;
    cloneOpts = [];

    curTeam: TeamCodes = <TeamCodes>{};
    clubConfig: CMClub;
    private destroy$ = new Subject<void>();

    constructor(private localService: LocalService,
        private _utilityService: UtilityService,
        private _clubService: CMClubService,
        private _globalService: GlobalService,
        private _router: Router,
        private _notifyService: NotificationService,
    ) {

        this.localService.setIsCmSite(true);
        this.localService.setShowMenu(true)
        this.localService.setRouteName('sm-triggers');
    }

    ngOnInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData()
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async loadData() {
        this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}");
        await this.CMClub_Get(() => {
            this.webFormListDDGet();
            this.automationProcessListGetByClub();
        });
        this.curSiteSub = this._clubService.curSite.pipe(takeUntil(this.destroy$)).subscribe(async (value: CMSite) => {
            this.curSite = await value;
            if (this.curSite == null) {
                this.curSite = await JSON.parse(localStorage.getItem("curSite") || '{}')
                this.getTrigger(this.curSite?.siteID);
                this.siteSearch();
            }
            else {
                this.getTrigger(this.curSite?.siteID);
                this.siteSearch();
            }
        })

    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async CMClub_Get(callback) {
        if (this.curTeam?.teamCode) {
            this.showSpinner = true
            await this._clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig;

                        if (callback) {
                            callback();
                        }
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    this._globalService.error("lm-triggers.CMClub_Get", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async webFormListDDGet() {
        this.showSpinner = true
        //await this._clubService.cm_Webform_GetList(this.encryptedUser, this.clpCompanyId, this.clubConfig?.clubId)
        await this._clubService.cm_Webform_GetList(this.encryptedUser, this.clpCompanyId, -1)
            .then(async (result: keyValue[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.webFormList = response
                    this.webFormList.unshift({
                        key: 0,
                        value: "--Select--",
                        isSelected: false
                    })
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async automationProcessListGetByClub() {
        this.showSpinner = true
        //await this._clubService.cm_CampaignTemplate_GetList(this.encryptedUser, this.clpCompanyId, this.clubConfig?.clubId)
        await this._clubService.cm_CampaignTemplate_GetList(this.encryptedUser, this.clpCompanyId, -1)
            .then(async (result: AutomationProcessDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.automationProcessList = response
                    this.automationProcessList.unshift({
                        campaignTemplateID: 0,
                        cLPUserID: 0,
                        cLPCompanyID: 0,
                        campaignTemplateName: "--Select--",
                        templateName: ""
                    })
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async triggerSaved() {
        this.site.siteID = this.curSite?.siteID ? this.curSite?.siteID : 0;
        this.site.newLead = this.newLeadId ? this.newLeadId : 0;
        this.site.newMember = this.newMemberId ? this.newMemberId : 0;
        this.site.contractSent = this.contractSent ? this.contractSent : 0;
        this.site.contractOpen = this.contractOpen ? this.contractOpen : 0;
        this.site.waitingCountersign = this.waitingCountersign ? this.waitingCountersign : 0;
        this.site.memberAdded = this.memberAdded ? this.memberAdded : 0;
        this.site.contractUpgraded = this.contractUpgraded ? this.contractUpgraded : 0;
        this.site.contractRenewed = this.contractRenewed ? this.contractRenewed : 0;
        this.site.memberTerminated = this.memberTerminated ? this.memberTerminated : 0;
        this.site.contractExpiration = this.contractExpired ? this.contractExpired : 0;
        this.site.contactUpdate = this.contactUpdateId ? this.contactUpdateId : 0;
        this.site.referralRequest = this.referralRequest ? this.referralRequest : 0;
        this.site.enableAutomationAlert = this.enableAutomationAlert;
        this.submitted = true
        await this._clubService.CMSite_Trigger_Update(this.encryptedUser, this.site).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this._notifyService?.showSuccess("Trigger saved successfully", "Success", 3000);
                }
                this.submitted = false
            })
            .catch((err: HttpErrorResponse) => {
                this.submitted = false
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getTrigger(siteId) {
        if (siteId > 0) {
            this.showSpinner = true
            await this._clubService.siteSearch(this.encryptedUser, siteId, 0, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                        if (this.sites.length > 0) {
                            this.newLeadId = this.sites[0]?.newLead > 0 ? this.sites[0]?.newLead : this.webFormList[0]?.key;
                            this.newMemberId = this.sites[0]?.newMember > 0 ? this.sites[0]?.newMember : this.webFormList[0]?.key;
                            this.contractSent = this.sites[0]?.contractSent > 0 ? this.sites[0]?.contractSent : this.webFormList[0]?.key;
                            this.contractOpen = this.sites[0]?.contractOpen > 0 ? this.sites[0]?.contractOpen : this.webFormList[0]?.key;
                            this.waitingCountersign = this.sites[0]?.waitingCountersign > 0 ? this.sites[0]?.waitingCountersign : this.automationProcessList[0]?.campaignTemplateID;
                            this.memberAdded = this.sites[0]?.memberAdded > 0 ? this.sites[0]?.memberAdded : this.automationProcessList[0]?.campaignTemplateID;
                            this.contractUpgraded = this.sites[0]?.contractUpgraded > 0 ? this.sites[0]?.contractUpgraded : this.automationProcessList[0]?.campaignTemplateID;
                            this.contractRenewed = this.sites[0]?.contractRenewed > 0 ? this.sites[0]?.contractRenewed : this.automationProcessList[0]?.campaignTemplateID;
                            this.memberTerminated = this.sites[0]?.memberTerminated > 0 ? this.sites[0]?.memberTerminated : this.automationProcessList[0]?.campaignTemplateID; 
                            this.contractExpired = this.sites[0]?.contractExpiration > 0 ? this.sites[0]?.contractExpiration : this.webFormList[0]?.key;
                            this.contactUpdateId = this.sites[0]?.contactUpdate > 0 ? this.sites[0]?.contactUpdate : this.automationProcessList[0]?.campaignTemplateID;
                            this.referralRequest = this.sites[0]?.referralRequest > 0 ? this.sites[0]?.referralRequest : this.automationProcessList[0]?.campaignTemplateID;
                            this.enableAutomationAlert = this.sites[0]?.enableAutomationAlert ?? true;
                        }
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this._notifyService.showSuccess("Site not found. Go back to configuration.", "Error", 3000);
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.curSiteSub) {
            this.curSiteSub.unsubscribe()
        }
    }

    async siteSearch() {
        if (this.curSite?.clubID > 0) {
            await this._clubService.siteSearch(this.encryptedUser, 0, this.curSite?.clubID, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites
                        this.cloneOpts = []
                        this.cloneOpts = [{ display: "-All Sites-", value: -1 }, { display: "-Cancel Clone-", value: 0 }]
                        this.sites.forEach((item) => {
                            if (item?.siteID != this.curSite?.siteID) {
                                let obj = {
                                    display: item?.siteName,
                                    value: item?.siteID
                                }
                                this.cloneOpts.push(obj)
                            }
                        })
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    onChangeCloneOpt(event) {
        let value = event?.target?.value
        if (value == 0) {
            this.isShowClone = false
        }
        else {
            this.cloneTriggers(value)
        }
    }

    async cloneTriggers(toSiteId: any) {
        if (this.curSite?.siteID > 0) {
            await this._clubService.cmSiteCloneTrigger(this.encryptedUser, this.user?.cLPCompanyID, this.curSite?.clubID, this.curSite?.siteID, toSiteId)
                .then(async (result: SimpleResponse) => {
                    if (result && result?.messageBool) {
                        let response = UtilityService.clone(result);
                        this.isShowClone = false
                        this._notifyService.showSuccess("Triggers has been cloned successfully.", "", 5000)
                    }
                    else {
                        this._notifyService.showError("Please reassign them and try again.", "", 15000)
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this._notifyService.showSuccess("No site selected.", "", 3000)
        }
    }


    showCloneDD() {
        this.isShowClone = true;
    }
}
